import React from 'react';

import * as styles from './TextBlock.styles';

interface TextBlockProps {
  bodyText?: string;
  footerLinkHref: string;
  footerLinkText: string;
  footerText: string;
  heading: string;
}

export const TextBlock = ({
  bodyText,
  footerLinkHref,
  footerLinkText,
  footerText,
  heading,
}: TextBlockProps) => {
  return (
    <section css={styles.root}>
      <h2>{heading}</h2>
      {bodyText &&
        bodyText
          .split('\n')
          .filter(Boolean)
          .map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      <p>
        {footerText} <a href={footerLinkHref}>{footerLinkText}</a>
      </p>
    </section>
  );
};
